/* ── MAVIS THEME JS v1.0 ── */

(function () {
  'use strict';

  // Skip animation hiding in Shopify Theme Editor so sections are always visible
  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  // ── MOBILE MENU ──
  // Define closeMob first so onclick="closeMob()" in HTML always resolves it
  window.closeMob = function () {
    var menu = document.getElementById('mobMenu');
    if (!menu) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // Use event delegation so it works regardless of when elements load
  document.addEventListener('click', function (e) {
    if (e.target.closest('#navBurger')) {
      var menu = document.getElementById('mobMenu');
      if (menu) {
        menu.classList.add('open');
        menu.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
      }
    }
    if (e.target.closest('#mobClose')) {
      window.closeMob();
    }
  });

  // Close on any link/card click inside the menu
  document.addEventListener('click', function (e) {
    var menu = document.getElementById('mobMenu');
    if (!menu || !menu.classList.contains('open')) return;
    if (e.target.closest('.mob-nav-card') || e.target.closest('.mob-support-card')) {
      window.closeMob();
    }
  });

  // ── SCROLL REVEAL ──
  var revObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.remove('reveal-pending');
        e.target.classList.add('visible');
        revObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) {
    if (!DESIGN_MODE) el.classList.add('reveal-pending');
    revObs.observe(el);
  });

  // ── POLAROID STAGGER ──
  var hiwSection = document.querySelector('.hiw');
  if (hiwSection) {
    var pols = hiwSection.querySelectorAll('.hiw-pol');
    if (!DESIGN_MODE) {
      pols.forEach(function (pol) { pol.classList.add('hiw-pol-pending'); });
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          pols.forEach(function (pol, i) {
            setTimeout(function () {
              pol.classList.remove('hiw-pol-pending');
              pol.classList.add('in-view');
            }, i * 150);
          });
        }
      });
    }, { threshold: 0.2 }).observe(hiwSection);
  }

  // ── COMMUNITY COUNT ──
  var ccNumEl = document.getElementById('ccNum');
  if (ccNumEl) {
    var CC_TARGET = parseInt(ccNumEl.dataset.target || '2847', 10);
    var ccFired = false;
    function startCountUp() {
      if (ccFired) return;
      ccFired = true;
      var t0 = performance.now();
      var DURATION = 1800;
      (function tick(now) {
        var p = Math.min((now - t0) / DURATION, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        ccNumEl.textContent = Math.round(ease * CC_TARGET).toLocaleString();
        if (p < 1) requestAnimationFrame(tick);
      })(performance.now());
    }
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) startCountUp();
    }, { threshold: 0.1 }).observe(ccNumEl.closest('section') || ccNumEl);
  }

  // ── PERSONA QUIZ ──
  // Named function so it can be called on initial load AND on shopify:section:load
  function initQuizSection(card, inner, cfgEl) {
    if (!card || !inner) return;

    var cfg = null;
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {} }

    var QUESTIONS = (cfg && cfg.questions && cfg.questions.length) ? cfg.questions : [
      {
        text: "What's your current era?",
        options: [
          { text: "First year. Everything feels new.", key: 'sara' },
          { text: "Senior year. I'm in my peak.", key: 'nour' },
          { text: "Almost done. Real life is next.", key: 'layla' }
        ]
      },
      {
        text: "Your cup goes...",
        options: [
          { text: "To class. Every single day.", key: 'sara' },
          { text: "Everywhere my girls go.", key: 'nour' },
          { text: "On my desk. It's part of my setup.", key: 'layla' }
        ]
      },
      {
        text: "Your style right now...",
        options: [
          { text: "Figuring it out — and that's okay.", key: 'sara' },
          { text: "I know exactly who I am.", key: 'nour' },
          { text: "Pulled together. Barely.", key: 'layla' }
        ]
      }
    ];

    var RESULTS = (cfg && cfg.results) ? cfg.results : {
      sara: {
        name: 'Sara', age: 19,
        avaStyle: 'background:#F0EFE9;color:#111111',
        accent: 'rgba(0,0,0,0.15)',
        desc: "You're still becoming you — and that's the whole point. Your Mavy is a blank slate that grows with the year. Clean, fresh, and completely yours.",
        cup: 'White Mavy 3.0', cupSub: '+ a sticker pack to start your story', cta: 'Shop White Mavy 3.0'
      },
      nour: {
        name: 'Nour', age: 17,
        avaStyle: 'background:#FFB8C6;color:#111111',
        accent: '#FFB8C6',
        desc: "You're in your era — and your entire squad is about to want matching ones. The cup for the girl who's fully herself and brings everyone along.",
        cup: 'Pink Mavy 2.0', cupSub: '+ shop the Besties Pack for your girls', cta: 'Shop the Pink Mavy'
      },
      layla: {
        name: 'Layla', age: 22,
        avaStyle: 'background:#111111;color:#ffffff',
        accent: '#111111',
        desc: "Clean, intentional, and somehow still yourself while everything gets serious. Your Mavy sits on your desk and reminds you who you still are.",
        cup: 'Black Mavy 2.0', cupSub: '+ stickers that belong on a desk', cta: 'Shop Black Mavy 2.0'
      }
    };

    var INTRO = (cfg && cfg.intro) ? cfg.intro : {
      eyebrow: '3 questions · 15 seconds',
      heading: 'Find your<br>Mavy match.',
      sub: "Tell us where you're at — we'll show you exactly which cup is yours.",
      cta: "Let's go →"
    };

    var answers = [];

    // Build tally keys from loaded RESULTS
    var tallyKeys = Object.keys(RESULTS);

    function transition(renderFn) {
      inner.classList.add('fading');
      setTimeout(function () { renderFn(); inner.classList.remove('fading'); }, 220);
    }

    function dots(current) {
      return QUESTIONS.map(function (_, i) {
        var cls = i < current ? 'done' : i === current ? 'active' : '';
        return '<span class="quiz-dot ' + cls + '"></span>';
      }).join('');
    }

    function showIntro() {
      answers = [];
      card.classList.add('yellow-bg');
      card.style.borderTop = 'none';
      inner.innerHTML =
        '<p class="quiz-intro-eyebrow">' + INTRO.eyebrow + '</p>' +
        '<h3 class="quiz-intro-h">' + INTRO.heading + '</h3>' +
        '<p class="quiz-intro-sub">' + INTRO.sub + '</p>' +
        '<button class="btn-quiz-start" data-action="start">' + INTRO.cta + '</button>';
    }

    function showQuestion(i) {
      var q = QUESTIONS[i];
      if (i % 2 === 1) {
        card.classList.add('yellow-bg');
        card.style.borderTop = 'none';
      } else {
        card.classList.remove('yellow-bg');
        card.style.borderTop = '1px solid var(--border)';
      }
      inner.innerHTML =
        '<div class="quiz-progress">' + dots(i) + '</div>' +
        '<p class="quiz-q-label">Question ' + (i + 1) + ' of ' + QUESTIONS.length + '</p>' +
        '<h3 class="quiz-q-text">' + q.text + '</h3>' +
        '<div class="quiz-options">' +
        q.options.map(function (o) {
          return '<button class="quiz-opt" data-action="answer" data-key="' + o.key + '" data-qi="' + i + '">' + o.text + '</button>';
        }).join('') +
        '</div>';
    }

    function showResult() {
      var tally = {};
      tallyKeys.forEach(function (k) { tally[k] = 0; });
      answers.forEach(function (k) { if (tally[k] !== undefined) tally[k]++; });
      var key = tallyKeys.reduce(function (a, b) { return tally[a] >= tally[b] ? a : b; });
      var r = RESULTS[key];
      card.classList.remove('yellow-bg');
      card.style.borderTop = '4px solid ' + r.accent;
      inner.innerHTML =
        '<div class="quiz-result-ava" style="' + r.avaStyle + '">' + r.name[0] + '</div>' +
        '<div class="quiz-result-name">You\'re ' + r.name + ' <span class="quiz-result-age">' + r.age + '</span></div>' +
        '<p class="quiz-result-desc">' + r.desc + '</p>' +
        '<div class="quiz-recommendation">' +
          '<p class="quiz-rec-label">Your Mavy</p>' +
          '<p class="quiz-rec-cup">' + r.cup + '</p>' +
          '<p class="quiz-rec-sub">' + r.cupSub + '</p>' +
        '</div>' +
        '<div class="quiz-result-actions">' +
          (r.productUrl ? '<a href="' + r.productUrl + '" class="btn-quiz-shop">' + r.cta + '</a>' : '') +
          '<button class="btn-quiz-retake" data-action="retake">Retake quiz</button>' +
        '</div>';
    }

    card.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.dataset.action;
      if (action === 'start') {
        transition(function () { showQuestion(0); });
      } else if (action === 'answer') {
        answers.push(btn.dataset.key);
        var next = parseInt(btn.dataset.qi, 10) + 1;
        transition(function () { next < QUESTIONS.length ? showQuestion(next) : showResult(); });
      } else if (action === 'retake') {
        transition(function () { showIntro(); });
      }
    });

    showIntro();
  }

  // Init quiz on normal page load
  (function () {
    var c = document.getElementById('quizCard');
    var n = document.getElementById('quizInner');
    var ce = document.getElementById('quizConfig');
    initQuizSection(c, n, ce);
  })();

  // ── CUP COMPARE CALLOUTS ──
  var compareZone = document.getElementById('compareCupZone');
  if (compareZone) {
    var specItems = compareZone.querySelectorAll('.spec-item');
    if (!DESIGN_MODE) {
      specItems.forEach(function (item) { item.classList.add('spec-pending'); });
    }
    var compFired = false;
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !compFired) {
        compFired = true;
        specItems.forEach(function (item, i) {
          setTimeout(function () {
            item.classList.remove('spec-pending');
            item.classList.add('in-view');
          }, i * 130);
        });
      }
    }, { threshold: 0.3 }).observe(compareZone);
  }

  // ── SMART NAV — hide on scroll down, reveal on scroll up ──
  var _navEl   = document.querySelector('nav');
  var _navLastY = window.scrollY;
  if (_navEl) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < 60) {
        _navEl.classList.remove('nav--hidden');
      } else if (y > _navLastY) {
        _navEl.classList.add('nav--hidden');
      } else {
        _navEl.classList.remove('nav--hidden');
      }
      _navLastY = y;
    }, { passive: true });
  }

  // ── STICKY MOBILE CTA ──
  var stickyCta = document.getElementById('stickyCta');
  var heroEl = document.querySelector('.hero');
  if (heroEl && stickyCta) {
    new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) {
        stickyCta.classList.add('show');
        document.body.classList.add('mob-cta-active');
      } else {
        stickyCta.classList.remove('show');
        document.body.classList.remove('mob-cta-active');
      }
    }, { threshold: 0 }).observe(heroEl);
  }

  // ── SHAPE MAVIS — type pill toggle ──
  var shapePills = document.querySelectorAll('.shape-type-pill');
  if (shapePills.length) {
    shapePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        shapePills.forEach(function (p) { p.classList.remove('selected'); });
        pill.classList.add('selected');
        var typeInput = document.getElementById('shapeType');
        if (typeInput) typeInput.value = pill.dataset.type;
      });
    });
  }

  // ── PRODUCT PAGE SETUP ──
  var _productCfg = {};
  var _cfgEl = document.getElementById('productConfig');
  if (_cfgEl) { try { _productCfg = JSON.parse(_cfgEl.textContent); } catch (e) {} }
  var ATC_ADD_TEXT = _productCfg.addToCartText || 'Add to Cart';
  var ATC_SOLD_TEXT = _productCfg.soldOutText || 'Sold Out';
  var ATC_ADDING_TEXT = _productCfg.addingText || 'Adding...';

  var _variantData = [];
  var _mediaData = [];
  var _variantJsonEl = document.getElementById('variantJson');
  var _mediaJsonEl = document.getElementById('productMediaJson');
  if (_variantJsonEl) { try { _variantData = JSON.parse(_variantJsonEl.textContent || '[]'); } catch (e) {} }
  if (_mediaJsonEl) { try { _mediaData = JSON.parse(_mediaJsonEl.textContent || '[]'); } catch (e) {} }

  var _galleryTrack = document.getElementById('galleryTrack');
  var _galleryDots  = document.getElementById('galleryDots');
  var _priceEl = document.getElementById('productPrice');

  function _getVariant(id) {
    return _variantData.find(function (v) { return v.id === id; });
  }

  function _setActiveDot(idx) {
    if (!_galleryDots) return;
    _galleryDots.querySelectorAll('.gallery-dot').forEach(function (dot, i) {
      dot.classList.toggle('active', i === idx);
    });
  }

  function _switchMedia(mediaId) {
    if (!mediaId || !_galleryTrack) return;
    var idx = _mediaData.findIndex(function (m) { return m.id === mediaId; });
    if (idx < 0) return;
    _galleryTrack.scrollTo({ left: idx * _galleryTrack.offsetWidth, behavior: 'smooth' });
    _setActiveDot(idx);
  }

  function _applyVariant(variant) {
    if (!variant) return;
    if (_priceEl) _priceEl.textContent = variant.price_formatted;
    var btn = document.querySelector('#productForm .product-atc');
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? ATC_ADD_TEXT : ATC_SOLD_TEXT;
    }
    if (variant.featured_media_id) _switchMedia(variant.featured_media_id);
  }

  var _varSel = document.getElementById('variantSelect');
  if (_varSel) {
    _varSel.addEventListener('change', function () {
      _applyVariant(_getVariant(parseInt(_varSel.value, 10)));
    });
    _applyVariant(_getVariant(parseInt(_varSel.value, 10)));
  }

  // Gallery: sync dots when user swipes
  if (_galleryTrack) {
    var _scrollTimer;
    _galleryTrack.addEventListener('scroll', function () {
      clearTimeout(_scrollTimer);
      _scrollTimer = setTimeout(function () {
        var idx = Math.round(_galleryTrack.scrollLeft / _galleryTrack.offsetWidth);
        _setActiveDot(idx);
      }, 50);
    }, { passive: true });
  }
  // Gallery: dot clicks scroll to slide
  if (_galleryDots) {
    _galleryDots.addEventListener('click', function (e) {
      var dot = e.target.closest('.gallery-dot');
      if (!dot || !_galleryTrack) return;
      var idx = parseInt(dot.dataset.index, 10);
      _galleryTrack.scrollTo({ left: idx * _galleryTrack.offsetWidth, behavior: 'smooth' });
      _setActiveDot(idx);
    });
  }

  // ── PRODUCT DESCRIPTION — Read more / Read less ──
  var _descEl   = document.getElementById('productDesc');
  var _descMore = document.getElementById('descMore');
  if (_descEl && _descMore) {
    if (_descEl.scrollHeight <= _descEl.clientHeight + 4) {
      _descMore.style.display = 'none';
    }
    _descMore.addEventListener('click', function () {
      var expanded = _descEl.classList.toggle('expanded');
      _descMore.textContent = expanded ? 'Read less' : 'Read more';
    });
  }

  // Quantity +/-
  var _qtyInput = document.getElementById('productQty');
  document.addEventListener('click', function (e) {
    if (!_qtyInput) return;
    if (e.target.id === 'qtyMinus') {
      var v = parseInt(_qtyInput.value, 10) || 1;
      if (v > 1) _qtyInput.value = v - 1;
    } else if (e.target.id === 'qtyPlus') {
      _qtyInput.value = (parseInt(_qtyInput.value, 10) || 1) + 1;
    }
  });

  // ── AJAX ADD TO CART ──
  var productForm = document.getElementById('productForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var atcBtn = productForm.querySelector('.product-atc');
      var originalText = atcBtn ? atcBtn.textContent : ATC_ADD_TEXT;
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = ATC_ADDING_TEXT;
      }

      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          showToast(data.description || 'Something went wrong.');
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText; }
          return;
        }
        updateCartCount();
        showToast('Added to cart!');
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText; }
      })
      .catch(function () {
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText; }
        showToast('Something went wrong. Please try again.');
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.cart-count');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.dataset.count = cart.item_count;
        });
      });
  }

  function showToast(msg) {
    var toast = document.getElementById('cartToast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  // Init cart count on page load
  updateCartCount();

  // ── SHOPIFY THEME EDITOR: re-init section features on reload ──
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;

    // Re-observe .reveal elements — clear any pending/visible state first.
    // In the Theme Editor (DESIGN_MODE) pending is never re-added, so content stays visible.
    root.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.remove('visible', 'reveal-pending');
      revObs.observe(el);
    });

    // Re-init HIW polaroid stagger — clear pending so polaroids are visible in editor
    var hiw = root.querySelector('.hiw');
    if (hiw) {
      var hiwPols = hiw.querySelectorAll('.hiw-pol');
      hiwPols.forEach(function (p) { p.classList.remove('in-view', 'hiw-pol-pending'); });
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          hiwPols.forEach(function (pol, i) {
            setTimeout(function () {
              pol.classList.remove('hiw-pol-pending');
              pol.classList.add('in-view');
            }, i * 150);
          });
        }
      }, { threshold: 0.2 }).observe(hiw);
    }

    // Re-init community count-up
    var cc = root.querySelector('#ccNum');
    if (cc) {
      var ccTarget = parseInt(cc.dataset.target || '2847', 10);
      var ccT0 = performance.now();
      var CC_DUR = 1800;
      (function tick(now) {
        var p = Math.min((now - ccT0) / CC_DUR, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        cc.textContent = Math.round(ease * ccTarget).toLocaleString();
        if (p < 1) requestAnimationFrame(tick);
      })(performance.now());
    }

    // Re-init cup compare callouts — clear pending so specs are visible in editor
    var cz = root.querySelector('#compareCupZone');
    if (cz) {
      var czItems = cz.querySelectorAll('.spec-item');
      czItems.forEach(function (item) { item.classList.remove('in-view', 'spec-pending'); });
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          czItems.forEach(function (item, i) {
            setTimeout(function () {
              item.classList.remove('spec-pending');
              item.classList.add('in-view');
            }, i * 130);
          });
        }
      }, { threshold: 0.3 }).observe(cz);
    }

    // Re-init quiz
    var qCard = root.querySelector('#quizCard');
    var qInner = root.querySelector('#quizInner');
    var qCfg = root.querySelector('#quizConfig');
    if (qCard && qInner) initQuizSection(qCard, qInner, qCfg);

    // Re-bind shape type pills
    var pills = root.querySelectorAll('.shape-type-pill');
    if (pills.length) {
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('selected'); });
          pill.classList.add('selected');
          var typeInput = document.getElementById('shapeType');
          if (typeInput) typeInput.value = pill.dataset.type;
        });
      });
    }
  });

})();
